import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Image = styled.img.attrs({
  className: 'rounded-circle',
})`
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  object-fit: cover;
`;

/**
 * Description
 * @param {any} props
 * @returns {React.ReactComponentElement} - AvatarImage component
 */
function AvatarImage({ image, size = '50px', username = null }) {
  return (
    <Image src={image} size={size} alt={username} />
  );
}

AvatarImage.propTypes = {
  image: PropTypes.string.isRequired,
  size: PropTypes.string,
  username: PropTypes.string,
};

export default AvatarImage;
